<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Analysis Sum'}} {{(mfSCHCode != '')? '-'+mfSCHCode: ''}} {{(rawData.length)? rawData[0]['SCH_NAME']: ''}}</strong>
        </div>
        <div class="col-md-5">          
        </div>
        <div class="col-md-1">
          <!-- <goback></goback> -->
          <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go Back</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5" v-if="!tableFields.length">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="durDate"
              @selected="getDateData($event)"
              :disabledDates="disabledDates"
              :placeholder="'Select Date'"
            ></datepicker>
          </div>
        </div>
      </div>
      <div class="row mb5">
        <div class="col-md-6">
          </div>
        </div>
        <div class="mb5"></div>
        <div class="row mb5">
          <div class="col-md-3">
            <span v-if="rawData.date"><strong>Date: {{rawData.date? getDate(sum.date): ''}}</strong></span>
          </div>
          <div class="col-md-3">
            <span v-if="rawData.date">Portfolio Overall Rating: {{rawData.date? getChecknFixed(sum.portfolio_overall_rating): ''}}</span>
          </div>
            <div class="col-md-3">
              <span v-if="rawData.avg_maturity"><strong>Average Maturity:</strong> {{getChecknFixed(rawData.avg_maturity)}} <br>{{rawData.avg_maturity_date? getDate(rawData.avg_maturity_date): ''}}</span>
            </div>
          <div class="col-md-2">
            <download :tableId="rawDataType" :fileName="rawDataType"></download>
          </div>
        </div>
        <div class="row mb5" v-if="tableFields1.length">
          <div class="col-md-3">
            <div class="form-group">
              <input
                type="text"
                v-model="scheme_name"
                class="form-control"
                name="search"
                placeholder="Search by scheme name"
              >
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <input
                type="text"
                v-model="searchText"
                class="form-control"
                name="search"
                placeholder="Search by Lname"
              >
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <v-select
                :options="fundManagerList"
                :placeholder="'Select Fund Manager'"
                :label="'name'"
                v-model="selFundManager"
              ></v-select>
            </div>
          </div>          
          <div class="col-md-3">
            <div class="form-group">
              <input
                type="text"
                v-model="category"
                class="form-control"
                name="search"
                placeholder="Search by category"
              >
            </div>
          </div>          
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchP11.min"
                class="form-control"
                name="search"
                placeholder="Min P11"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchP11.max"
                class="form-control"
                name="search"
                placeholder="Max P11"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchp11qtr.min"
                class="form-control"
                name="search"
                placeholder="Min P11 quarterly trends"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchp11qtr.max"
                class="form-control"
                name="search"
                placeholder="Max P11 quarterly trends"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchq1ab.min"
                class="form-control"
                name="search"
                placeholder="Min Q1 A/B"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchq1ab.max"
                class="form-control"
                name="search"
                placeholder="Max Q1 A/B"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchPortfolioRating.min"
                class="form-control"
                name="search"
                placeholder="Min Portfolio Ratings"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <input
                type="text"
                v-model="searchPortfolioRating.max"
                class="form-control"
                name="search"
                placeholder="Max Portfolio Ratings"
              >
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <button class="btn btn-primary" @click="filterSchemes">Filter</button>
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <button class="btn btn-default" @click="resetFilter">Reset</button>
            </div>
          </div>
        </div>
        <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length || tableFields1.length">
          <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
            <thead>
              <tr>
                <th v-if="tableFields1.length">Sr.</th>
                <th
                  class="data-cell"
                  v-for="(field, index) in tableFields"
                  v-bind:key="index+'field'+field.title"
                >{{field.name}}</th>
                <th
                  class="data-cell"
                  @click="sortColumnByName(field, index)"
                  v-for="(field, index) in tableFields1"
                  v-bind:key="index+'sumfield'+field.title"
                >
                <span>{{field.name}}
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort == 1 || field.sort == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort == 2 || field.sort == 0)"
                  ></i>
                </span>
                </th>
                <th v-for="(field, index) in ratings.subFields" v-bind:key="'ratingsth'+ field.title+index">
                  {{field.name}}
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort == 1 || field.sort == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort == 2 || field.sort == 0)"
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody v-if="rawData.date">
              <tr>
                <td v-for="(cl, index) in tableFields"
                  v-bind:key="index+'cldata'+cl.title" class="text-bold">
                  <span v-if="cl.datatype=='numeric'">{{(sum[cl.title+'_sum'])? getChecknFixed(sum[cl.title+'_sum']): (sum[cl.title])? getChecknFixed(sum[cl.title]): '-'}}</span>
                  <span v-else-if="cl.datatype=='date'">{{(sum[cl.title+'_sum'])? getDate(sum[cl.title+'_sum']): (sum[cl.title])? getDate(sum[cl.title]): '-'}}</span>
                  <span v-else>{{(sum[cl.title+'_sum'])? sum[cl.title+'_sum']: (sum[cl.title])? sum[cl.title]: ''}}</span>
                </td>
                <td v-for="(cl, index) in ratings.subFields" v-bind:key="'ratingstd'+ cl.title+index">
                  <span v-if="cl.datatype=='numeric'">
                    {{(sum['ratings']['raw'][cl.title])? (sum['ratings']['raw'][cl.title]): '-'}}
                    {{(sum['ratings']['label'][cl.title])? '('+(sum['ratings']['label'][cl.title])+')': '-'}}                  
                  </span>
                </td>
              </tr>
            </tbody>
            <tbody v-if="tableFields1.length">
              <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                  <td>{{ind+1}}</td>
                <td v-for="(cl, index) in tableFields1"
                  v-bind:key="index+'cldata'+cl.title" >
                  <span v-if="cl.datatype=='numeric'">{{(tr[cl.title+'_sum'])? getChecknFixed(tr[cl.title+'_sum']): (tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                  <span v-else-if="cl.datatype=='date'">{{(tr[cl.title+'_sum'])? getDate(tr[cl.title+'_sum']): (tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                  <span v-else>{{(tr[cl.title+'_sum'])? tr[cl.title+'_sum']: (tr[cl.title])? tr[cl.title]: ''}}</span>
                </td>
                <td v-for="(cl, index) in ratings.subFields" v-bind:key="'ratingstd'+ cl.title+index">
                  <span v-if="cl.datatype=='numeric'">
                    {{(tr['ratings'] && tr['ratings']['raw'] && tr['ratings']['raw'][cl.title])? (tr['ratings']['raw'][cl.title]): '-'}}
                    {{(tr['ratings'] && tr['ratings']['label'] && tr['ratings']['label'][cl.title])? '('+(tr['ratings']['label'][cl.title])+')': '-'}}                  
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb5 mt10" v-if="mfSCHCode != ''">
          <div class="col-md-4" v-if="rawData && (rawData['q1_a_greater'] ||rawData['q1_b_greater'])">
                <div class="row">
                  <div class="col-md-9">
                    <h3>Growth Vs. Value</h3>
                  </div>
                  <div class="col-md-3">
                  <download :tableId="'qab-'+rawDataType" :fileName="'qab'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
                  </div>
                </div>
                <table class="table table-bordered font11" :id="'qab-'+rawDataType">
                  <tbody>
                    <tr>
                      <td class="text-bold">Q1 A Greater</td>
                      <td>
                        <span>
                          {{getFixed(valueVsGrowthTotal.value)}}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-bold">Q1 B Greater</td>
                      <td>
                        <span>
                          {{getFixed(valueVsGrowthTotal.growth)}}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-bold">Total</td>
                      <td class="text-bold">{{getFixed(valueVsGrowthTotal.total)}}</td>
                    </tr>
                  </tbody>
                </table>
          </div>          
          <div class="col-md-8" v-if="rawData && valueGrowthData.length > 0">
            <div class="row">
              <div class="col-md-9">
                <h3>Growth Vs. Value</h3>
              </div>
              <div class="col-md-3">
              <download :tableId="'q1a'+rawDataType" :fileName="'q1a'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'q1a'+rawDataType">
              <thead><tr><th>Name</th><th>Value</th><th>Growth</th><th>Total</th></tr></thead>
              <tbody>
                <tr v-for="(item, ind) in valueGrowthData" v-bind:key="'q1a'+ind">
                  <td>{{item.title}}</td>
                  <td>{{item.value ?  getFixed(item.value)+"%" : '-'}}<br/>{{item.noofstocksv}}</td>
                  <td>{{item.growth ? getFixed(item.growth)+"%" : '-'}}<br/>{{item.noofstocksg}}</td>
                  <td>{{item.sum ? getFixed(item.sum)+"%" : '-'}}<br/>{{item.noofstocksmcap}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(valueVsGrowthTotal.value)+"%"}}<br/>{{valueVsGrowthTotal.noofstocksv}}</td>
                  <td class="text-bold">{{getFixed(valueVsGrowthTotal.growth)+"%"}}<br/>{{valueVsGrowthTotal.noofstocksg}}</td>
                  <td class="text-bold">{{getFixed(valueVsGrowthTotal.total)+"%"}}<br/>{{valueVsGrowthTotal.noofstocks}}</td>
                </tr>
              </tbody>
            </table>
          </div>                  
          <div class="col-md-12" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.credit_ratings">
            <div class="row">
              <div class="col-md-9">
                <h3>Typewise Ratings</h3>
              </div>
              <div class="col-md-3">
              <download :tableId="'cr-'+rawDataType" :fileName="'cr'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'cr-'+rawDataType">
              <thead>
                <tr>
                <th v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crth'+ind">{{cr.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(crData, ind) in rawData.holdings_summary.credit_ratings" v-bind:key="'crtr'+ind">
                  <td v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crtd'+ind">
                    <span v-if="cr.datatype == 'numeric'">
                      {{(crData[cr.title])? getFixed(crData[cr.title]): ''}}
                    </span>
                    <span v-else>{{crData[cr.title]}}</span>
                  </td>
                </tr>
                <tr>
                  <!-- <td > <b> {{ getFixed(getPercentHoldingTotal)  }} </b>  </td> -->
                  <td v-for="(cr, tdInd) in creditRatingsKeys" :key="tdInd + 'crtotal'">
                    <span v-if="cr.title == 'name'"><b>Total</b></span>
                    <span v-else-if="cr.title == 'type'"><b></b></span>
                    <span v-else-if="cr.title != 'type' && cr.title != 'name'"><b> {{ getFixed(rawData.holdings_summary['totals']['credit_ratings'][cr.title])  }} </b></span>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.top_3_exposures">
            <div class="row">
              <div class="col-md-9">
              <h3>Top 3 Exposures</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'exp'+rawDataType" :fileName="'exp-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'exp'+rawDataType">
              <thead><tr><th>Sectors</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(exp, ind) in top3exposuresKeys" v-bind:key="'exp'+ind">
                <td>{{exp}}</td>
                <td>{{(rawData.holdings_summary['top_3_exposures'] && rawData.holdings_summary['top_3_exposures'][exp])? getFixed(rawData.holdings_summary['top_3_exposures'][exp]): ''}}</td>
              </tr>
              <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                <td class="text-bold">Total</td>
                <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['top_3_exposures'])}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.top_3_industrywise">
            <div class="row">
              <div class="col-md-9">
                <h3>Top 3 Industry Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'ind'+rawDataType" :fileName="'ind-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'ind'+rawDataType" >
              <thead><tr><th>Industry</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(tind, ind) in top3industryKeys" v-bind:key="'tind'+ind">
                <td>{{tind}}</td>
                <td>{{(rawData.holdings_summary['top_3_industrywise'] && rawData.holdings_summary['top_3_industrywise'][tind])? getFixed(rawData.holdings_summary['top_3_industrywise'][tind]): ''}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['top_3_industrywise'])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
            <div class="row">
              <div class="col-md-11">
              <h3>Business Ratingwise Holdings</h3>
              </div>
              <div class="col-md-1">
                <download :tableId="'br'+rawDataType" :fileName="'br-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'br'+rawDataType">
              <thead><tr><th>Business Ratings</th><th>% Holding</th></tr></thead>
              <tbody>
                <tr v-for="(brate, ind) in businessRatingKeys" v-bind:key="'type'+ind">
                  <td>
                    <star-rating v-bind:increment="0.5"
                        v-bind:max-rating="7"
                        :rating="parseInt(brate)"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#868e96"
                        active-color="#ffbf00"
                        v-bind:star-size="20"
                      ></star-rating>
                  </td>
                  <td>{{(rawData.holdings_summary['psumratingwise'] && rawData.holdings_summary['psumratingwise']['business_rating'] && rawData.holdings_summary['psumratingwise']['business_rating'][brate])? getFixed(rawData.holdings_summary['psumratingwise']['business_rating'][brate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['psumratingwise']['business_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div>              
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
            <div class="row">
              <div class="col-md-9">
                <h3>Debt Ratingwise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'debt'+rawDataType" :fileName="'debt-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'debt'+rawDataType">
              <thead><tr><th>Debt Rating</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(qrate, ind) in debtRatingKeys" v-bind:key="'type'+ind">
                <td><star-rating v-bind:increment="0.5"
                      v-bind:max-rating="7"
                      :rating="parseInt(qrate)"
                      :read-only="true"
                      :show-rating="false"
                      inactive-color="#868e96"
                      active-color="#ffbf00"
                      v-bind:star-size="20"
                    ></star-rating></td>
                <td>{{(rawData.holdings_summary['psumratingwise'] && rawData.holdings_summary['psumratingwise']['debt_rating'] && rawData.holdings_summary['psumratingwise']['debt_rating'][qrate])? getFixed(rawData.holdings_summary['psumratingwise']['debt_rating'][qrate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['psumratingwise']['debt_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div> 
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
            <div class="row">
              <div class="col-md-9">
                <h3>Valuation Ratingwise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'vr'+rawDataType" :fileName="'vr-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'vr'+rawDataType">
              <thead><tr><th>Valuation Ratings</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(vrate, ind) in valuationRatingKeys" v-bind:key="'type'+ind">
                <td>
                  <star-rating v-bind:increment="0.5"
                      v-bind:max-rating="5"
                      :rating="parseInt(vrate)"
                      :read-only="true"
                      :show-rating="false"
                      inactive-color="#868e96"
                      active-color="#ffbf00"
                      v-bind:star-size="20"
                    ></star-rating>
                    </td>
                <td>{{(rawData.holdings_summary['psumratingwise'] && rawData.holdings_summary['psumratingwise']['valuation_rating'] && rawData.holdings_summary['psumratingwise']['valuation_rating'][vrate])? getFixed(rawData.holdings_summary['psumratingwise']['valuation_rating'][vrate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['psumratingwise']['valuation_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div>
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.psumratingwise">
            <div class="row">
              <div class="col-md-9">
                <h3>Quarterly Ratingwise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'qr'+rawDataType" :fileName="'qr-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'qr'+rawDataType">
              <thead><tr><th>Quarterly Rating</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(qrate, ind) in qtrRatingKeys" v-bind:key="'type'+ind">
                <td><star-rating v-bind:increment="0.5"
                      v-bind:max-rating="5"
                      :rating="parseInt(qrate)"
                      :read-only="true"
                      :show-rating="false"
                      inactive-color="#868e96"
                      active-color="#ffbf00"
                      v-bind:star-size="20"
                    ></star-rating></td>
                <td>{{(rawData.holdings_summary['psumratingwise'] && rawData.holdings_summary['psumratingwise']['quarterly_rating'] && rawData.holdings_summary['psumratingwise']['quarterly_rating'][qrate])? getFixed(rawData.holdings_summary['psumratingwise']['quarterly_rating'][qrate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['psumratingwise']['quarterly_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div>        
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.mcaptypewise">
            <div class="row">
              <div class="col-md-9">
              <h3>MCapwise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'mcap'+rawDataType" :fileName="'mcap-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'mcap'+rawDataType">
              <thead><tr><th>MCapwise</th><th>% Holding</th><th>Count</th></tr></thead>
              <tbody><tr v-for="(mcap, ind) in mcapKeys" v-bind:key="'mcap'+ind">
                  <td>{{mcap}}</td>
                  <td>{{(rawData.holdings_summary['mcaptypewise'] && rawData.holdings_summary['mcaptypewisenew']['PERC_HOLD'][mcap])? getFixed(rawData.holdings_summary['mcaptypewisenew']['PERC_HOLD'][mcap]): ''}}</td>
                  <td>{{(rawData.holdings_summary['mcaptypewise'] && rawData.holdings_summary['mcaptypewisenew']['number'][mcap])? (rawData.holdings_summary['mcaptypewisenew']['number'][mcap]): ''}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['mcaptypewise'])}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <!---- RATINGEQUITY - ---->
          <div class="col-md-6"></div>
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
            <div class="row">
              <div class="col-md-11">
              <h3>Business Ratingwise Holdings (Equity)</h3>
              </div>
              <div class="col-md-1">
                <download :tableId="'br-e'+rawDataType" :fileName="'br-Eq'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'br-e'+rawDataType">
              <thead><tr><th>Business Ratings</th><th>% Holding</th></tr></thead>
              <tbody>
                <tr v-for="(brate, ind) in businessRatingKeys" v-bind:key="'type'+ind">
                  <td>
                    <star-rating v-bind:increment="0.5"
                        v-bind:max-rating="7"
                        :rating="parseInt(brate)"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#868e96"
                        active-color="#ffbf00"
                        v-bind:star-size="20"
                      ></star-rating>
                  </td>
                  <td>{{(rawData.holdings_summary['ratings_equity'] && rawData.holdings_summary['ratings_equity']['business_rating'] && rawData.holdings_summary['ratings_equity']['business_rating'][brate])? getFixed(rawData.holdings_summary['ratings_equity']['business_rating'][brate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['ratings_equity']['business_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div>              
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
            <div class="row">
              <div class="col-md-9">
                <h3>Debt Ratingwise Holdings (Equity)</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'debt-e'+rawDataType" :fileName="'debt-Eq'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'debt-e'+rawDataType">
              <thead><tr><th>Debt Rating</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(qrate, ind) in debtRatingKeys" v-bind:key="'type'+ind">
                <td><star-rating v-bind:increment="0.5"
                      v-bind:max-rating="7"
                      :rating="parseInt(qrate)"
                      :read-only="true"
                      :show-rating="false"
                      inactive-color="#868e96"
                      active-color="#ffbf00"
                      v-bind:star-size="20"
                    ></star-rating></td>
                <td>{{(rawData.holdings_summary['ratings_equity'] && rawData.holdings_summary['ratings_equity']['debt_rating'] && rawData.holdings_summary['ratings_equity']['debt_rating'][qrate])? getFixed(rawData.holdings_summary['ratings_equity']['debt_rating'][qrate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['ratings_equity']['debt_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div> 
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
            <div class="row">
              <div class="col-md-9">
                <h3>Valuation Ratingwise Holdings (Equity)</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'vr-e'+rawDataType" :fileName="'vr-Eq'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'vr-e'+rawDataType">
              <thead><tr><th>Valuation Ratings</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(vrate, ind) in valuationRatingKeys" v-bind:key="'type'+ind">
                <td>
                  <star-rating v-bind:increment="0.5"
                      v-bind:max-rating="5"
                      :rating="parseInt(vrate)"
                      :read-only="true"
                      :show-rating="false"
                      inactive-color="#868e96"
                      active-color="#ffbf00"
                      v-bind:star-size="20"
                    ></star-rating>
                    </td>
                <td>{{(rawData.holdings_summary['ratings_equity'] && rawData.holdings_summary['ratings_equity']['valuation_rating'] && rawData.holdings_summary['ratings_equity']['valuation_rating'][vrate])? getFixed(rawData.holdings_summary['ratings_equity']['valuation_rating'][vrate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['ratings_equity']['valuation_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div>
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity">
            <div class="row">
              <div class="col-md-9">
                <h3>Quarterly Ratingwise Holdings (Equity)</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'qr-e'+rawDataType" :fileName="'qr-Eq'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'qr-e'+rawDataType">
              <thead><tr><th>Quarterly Rating</th><th>% Holding</th></tr></thead>
              <tbody><tr v-for="(qrate, ind) in qtrRatingKeys" v-bind:key="'type'+ind">
                <td><star-rating v-bind:increment="0.5"
                      v-bind:max-rating="5"
                      :rating="parseInt(qrate)"
                      :read-only="true"
                      :show-rating="false"
                      inactive-color="#868e96"
                      active-color="#ffbf00"
                      v-bind:star-size="20"
                    ></star-rating></td>
                <td>{{(rawData.holdings_summary['ratings_equity'] && rawData.holdings_summary['ratings_equity']['quarterly_rating'] && rawData.holdings_summary['ratings_equity']['quarterly_rating'][qrate])? getFixed(rawData.holdings_summary['ratings_equity']['quarterly_rating'][qrate]): 'NA'}}</td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['ratings_equity']['quarterly_rating'])}}</td>
                </tr>
                </tbody>
            </table>
          </div>
          <div class="col-md-6" v-if="rawData && rawData.frontend_data && rawData.frontend_data.raw && rawData.frontend_data.number">
            <div class="row">
              <div class="col-md-9">
              <h3>Overall Ratings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'overallrating'+rawDataType" :fileName="'overallrating-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'overallrating'+rawDataType">
            <thead><tr><th></th><th>Rating</th><th>Star</th></tr></thead>
            <tbody>
              <tr v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd+'overall'">
                <td>{{overallRate.name}}</td>
                <td>{{(rawData.frontend_data.raw[overallRate.title])? getFixed(rawData.frontend_data.raw[overallRate.title]): ''}}</td>
                <td>
                  <span v-if="overallRate.title == 'overall_business_rating' && overallRate.title == 'overall_debt_others_rating' && overallRate.title == 'overall_equity_rating'">
                    <star-rating v-bind:increment="0.5"
                        v-bind:max-rating="7"
                        :rating="parseInt(rawData.frontend_data.number[overallRate.title])"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#868e96"
                        active-color="#ffbf00"
                        v-bind:star-size="20"
                      ></star-rating>
                    </span>
                    <span v-else>
                    <star-rating v-bind:increment="0.5"
                        v-bind:max-rating="5"
                        :rating="parseInt(rawData.frontend_data.number[overallRate.title])"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#868e96"
                        active-color="#ffbf00"
                        v-bind:star-size="20"
                      ></star-rating>
                    </span>
                </td>
              </tr>
            </tbody>
            </table>
          </div> 
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratings_equity && rawData.holdings_summary.ratings_equity.mcaptypewise">
            <div class="row">
              <div class="col-md-9">
              <h3>MCapwise Holdings (Equity)</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'mcap-e-'+rawDataType" :fileName="'mcap-Eq'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'mcap-e-'+rawDataType">
            <thead><tr><th>MCapwise</th><th>% Holding</th><th>Count</th></tr></thead>
            <tbody><tr v-for="(mcap, ind) in mcapKeys" v-bind:key="'mcap'+ind">
                <td>{{mcap}}</td>
                <td>{{(rawData.holdings_summary.ratings_equity['mcaptypewise'] && rawData.holdings_summary.ratings_equity['mcaptypewise']['PERC_HOLD'][mcap])? getFixed(rawData.holdings_summary.ratings_equity['mcaptypewise']['PERC_HOLD'][mcap]): ''}}</td>
                <td>{{(rawData.holdings_summary.ratings_equity['mcaptypewise'] && rawData.holdings_summary.ratings_equity['mcaptypewise']['number'][mcap])? (rawData.holdings_summary.ratings_equity['mcaptypewise']['number'][mcap]): ''}}</td>
              </tr>
              <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                <td class="text-bold">Total</td>
                <td class="text-bold">{{getFixed(rawData.holdings_summary.totals.ratings_equity['mcaptypewise']['PERC_HOLD'])}}</td>
                <td></td>
              </tr>
            </tbody>
            </table>
          </div>
          <!------ END RATING EQUITY ----->
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.typewise">
            <div class="row">
              <div class="col-md-9">
              <h3>Typewise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'type'+rawDataType" :fileName="'type-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'type'+rawDataType">
              <thead><tr><th>Type</th><th>% Holding</th><th>Count</th></tr></thead>
              <tbody>
                <tr v-for="(sector, secInd) in rawData.holdings_summary.typewise" v-bind:key="'tr-sector'+secInd">
                    <td v-for="(industry, ind) in typewiseKeys" v-bind:key="'td-sector'+ind">{{sector[industry.title]}}</td>
                  </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['typewise'])}}</td>
                  <td></td>
                </tr>    
              </tbody>  
            </table>
          </div>
          <div class="col-md-12" v-if="rawData && rawData.frontend_data && rawData.frontend_data.schemes_under_fof && rawData.frontend_data.schemes_under_fof.length">
              <div class="row">
                <div class="col-md-9">
                <h3>FoFs Overall Ratings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'overallrating'+rawDataType" :fileName="'overallrating-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'schemeFofooverallrating'+rawDataType">
              <thead><tr><th>Scheme Name</th><th>% Holding</th><th v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd+'overall'">{{overallRate.name}}</th></tr></thead>
              <tbody>
                <tr v-for="(schemeData, schInd) in rawData.frontend_data.schemes_under_fof" :key="schInd+'schemefofOverall'">
                  <td>{{schemeData.sch_name}}</td>
                  <td>{{schemeData['PERC_HOLD']}}</td>
                  <td v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd+'overall'">{{(schemeData.frontend_data.raw[overallRate.title])? getFixed(schemeData.frontend_data.raw[overallRate.title]): ''}}</td>
                </tr>
                <tr>
                  <td class="text-bold">Total</td><td>{{(rawData['PERC_HOLD'])? getFixed(rawData['PERC_HOLD']): ''}}</td>
                  <td v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd+'overall'">{{(rawData.frontend_data.raw[overallRate.title])? getFixed(rawData.frontend_data.raw[overallRate.title]): ''}}</td>
                </tr>
              </tbody>
              </table>
            </div>  
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.ratingwise">
            <div class="row">
              <div class="col-md-9">
                <h3>Ratingwise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'rating'+rawDataType" :fileName="'rating-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'rating'+rawDataType">
              <thead>
                <tr>
                  <th  v-for="(rating, ind) in crRatingKeys" v-bind:key="'ratingth'+ind">{{rating.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(industry, ind) in rawData.holdings_summary['ratingwise']" v-bind:key="'ratingt'+ind">
                  <td v-for="(rating, index) in crRatingKeys" v-bind:key="'ratingr' + index">
                    <span v-if="rating.datatype == 'numeric'">{{(industry[rating.title])? getFixed(industry[rating.title]): ''}}</span>
                    <span v-else>{{(industry[rating.title])? (industry[rating.title]): ''}}</span>
                  </td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['ratingwise'])}}</td>
                </tr>
              </tbody>
            </table>
          </div> 
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.clubbed_ratings">
            <div class="row">
              <div class="col-md-9">
                <h3>Mixed Ratingwise Holdings</h3>
              </div>
              <div class="col-md-3">
                <download :tableId="'rating'+rawDataType" :fileName="'rating-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
              </div>
            </div>
            <table class="table table-bordered font11" :id="'rating'+rawDataType">
              <thead>
                <tr>
                  <th  v-for="(rating, ind) in crRatingKeys" v-bind:key="'ratingth'+ind">{{rating.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(industry, ind) in rawData.holdings_summary['clubbed_ratings']" v-bind:key="'ratingt'+ind">
                  <td v-for="(rating, index) in crRatingKeys" v-bind:key="'ratingr' + index">
                    <span v-if="rating.datatype == 'numeric'">{{(industry[rating.title])? getFixed(industry[rating.title]): ''}}</span>
                    <span v-else>{{(industry[rating.title])? (industry[rating.title]): ''}}</span>
                  </td>
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['clubbed_ratings'])}}</td>
                </tr>
              </tbody>
            </table>
          </div>           
          <div class="col-md-6" v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.industrywise">
            <div class="row">
              <div class="col-md-9">
                <h3>Industrywise Holdings</h3>
                </div>
                <div class="col-md-3">
                  <download :tableId="'indu'+rawDataType" :fileName="'industry-'+rawDataType + ((selScheme && selScheme.id)? selScheme.id: '')"></download>
                </div>
              </div>
              <table class="table table-bordered font11" :id="'indu'+rawDataType">
              <thead><tr><th v-for="(industry, ind) in industryKeys" v-bind:key="'industry'+ind">{{industry.name}}</th></tr></thead>
              <tbody>
                <tr v-for="(sector, secInd) in rawData.holdings_summary.industrywise" v-bind:key="'tr-sector'+secInd">
                  <td v-for="(industry, ind) in industryKeys" v-bind:key="'td-sector'+ind">{{sector[industry.title]}}</td>
                  <!-- <td>{{(rawData.holdings_summary['industrywise'] && rawData.holdings_summary['industrywise'][industry])? getFixed(rawData.holdings_summary['industrywise'][industry]): ''}}</td> -->
                </tr>
                <tr v-if="rawData && rawData.holdings_summary && rawData.holdings_summary.totals">
                  <td class="text-bold">Total</td>
                  <td class="text-bold">{{getFixed(rawData.holdings_summary.totals['industrywise'])}}</td>
                </tr>
              </tbody>
              </table>
          </div>           
        </div>
        <div class="row mb5" v-if="!tableFields.length && mfSCHCode && mfSCHCode != ''">
          <div class="col-md-12"><div class="alert alert-danger" role="alert">No data found!</div></div>
        </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import StarRating from "vue-star-rating";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { VueTabs, VTab, StarRating, Datepicker },
  mixins: [commonMixins, rawMixins],
  created() {
    console.log('PARAM', this.$route.params.id);
    if(this.$route.params.id) {
      this.showSchemeHoldings(this.$route.params.id);
      this.mfSCHCode = this.$route.params.id;
    } else {
      this.rawData = [];
      this.getFundManagerList();
      this.showSchemeHoldings();
    }
    console.log("Rawtype", this.rawDataType, this.mfSCHCode);
  },
  methods: {
    showSchemeHoldings(mfcode = null) {
      console.log('mfcode', mfcode, this.rawDataApi);
      this.rawData = [];
      // this.tableFields = [];
      let myself = this;
      var APIUrl = this.rawDataApi + 'analysis-sum';
      if(mfcode!=null){
        APIUrl = APIUrl + '/' + mfcode;
        if(this.durDate!=null) {
          APIUrl = APIUrl + '?date=' + this.getYMDDate(this.durDate);
        }
      }
      http.get(
        APIUrl,
        {},
        (error, response) => {
          console.log("Response", response.data);
          if(response.status == 'success') {
            this.rawData = response.data.date ? response.data : response.data;
            this.searchData = this.rawData;
            this.sum = response.data.date? response.data: [];
            console.log(this.rawData);
            if(response.data.date) {
              this.tableFields1 = [];
              // this.industryKeys = Object.keys(response.data.holdings_summary.industrywise);
              this.mcapKeys = Object.keys(response.data.holdings_summary.mcaptypewise);
              // this.typewiseKeys = Object.keys(response.data.holdings_summary.typewise);
              let typewiseKeys = Object.keys(response.data.holdings_summary.typewise);
              let typewiseData = [];
              typewiseKeys.forEach((indVal, indKey) => {
                typewiseData.push({ name: indVal, value: parseFloat(response.data.holdings_summary.typewise[indVal].toFixed(2)), 'holdCount': response.data.holdings_summary.typewisenumber[indVal] });
              });
              this.rawData.holdings_summary.typewise = this.sorted_fields_desc(typewiseData, 'value');
              console.log(this.rawData.holdings_summary.typewise);
              this.top3exposuresKeys = Object.keys(response.data.holdings_summary.top_3_exposures);
              this.top3industryKeys = Object.keys(response.data.holdings_summary.top_3_industrywise);
              // this.crRatingKeys = Object.keys(response.data.holdings_summary.ratingwise);
              this.businessRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.business_rating)? Object.keys(response.data.holdings_summary.psumratingwise.business_rating).reverse(): [];
              this.valuationRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.valuation_rating)? Object.keys(response.data.holdings_summary.psumratingwise.valuation_rating).reverse(): [];
              this.qtrRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.quarterly_rating)? Object.keys(response.data.holdings_summary.psumratingwise.quarterly_rating).reverse(): [];
              this.debtRatings = (response.data.holdings_summary.psumratingwise && response.data.holdings_summary.psumratingwise.debt_rating)? Object.keys(response.data.holdings_summary.psumratingwise.debt_rating).reverse(): [];
              // this.creditRatingsKeys = (response.data.holdings_summary.credit_ratings && response.data.holdings_summary.credit_ratings)? Object.keys(response.data.holdings_summary.credit_ratings).reverse(): [];
              let industryKeys = Object.keys(this.rawData.holdings_summary.industrywise);
              let industryData = [];
              industryKeys.forEach((indVal, indKey) => {
                industryData.push({ name: indVal, value: parseFloat(response.data.holdings_summary.industrywise[indVal].toFixed(2)) });
              });
              this.rawData.holdings_summary.industrywise = this.sorted_fields_desc(industryData, 'value');
              //RatingWise
              let ratingKeys = this.rawData.holdings_summary.ratingwise;
              let ratingData = [];
              ratingKeys.forEach((indVal, indKey) => {
                ratingData.push({ 
                  name: indVal.name,
                  PERC_HOLD: parseFloat(indVal['PERC_HOLD'].toFixed(2)),
                  sort_order: (indVal.name === 'AAA') ? 1 : (indVal.name === 'AA+') ? 2 : (indVal.name === 'AA') ? 3: (indVal.name === 'AA-')? 4: (indVal.name === 'A+')? 5: (indVal.name === 'EQUITY')? 6: 9
                  });
              });
              this.rawData.holdings_summary.ratingwise = this.sorted_fields_asc(ratingData, 'sort_order');
              console.log(this.rawData.holdings_summary.ratingwise);
            } else {
              this.tableFields = [];
            }
            // console.log("this.rawData", this.rawData);
            const q1_a_greaterValue = this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['PERC_HOLD'];
            const q1_b_greaterGrowth = this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['PERC_HOLD'];
            this.valueGrowthData = [];
            this.valueVsGrowthTotal = { value: 0, growth: 0, total: 0, noofstocksv: 0 , noofstocksg: 0, noofstocks: 0 };   
            let valueTotal = 0;
            let overAllTotal = 0;
            if(q1_a_greaterValue) {
              for(let [item, key] of Object.entries(q1_a_greaterValue)) {
                console.log('item', item); 
                let growthValueData = {
                  title: '',
                  value: '',
                  growth: '',
                  sum: 0,
                }
                growthValueData.title = item;
                growthValueData.value = key;
                growthValueData.sum += key;
                valueTotal = valueTotal + key;
                overAllTotal = overAllTotal + key;
                growthValueData.noofstocksv = this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                growthValueData.noofstocksmcap += this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                noofstocksv += this.valueVsGrowthTotal.noofstocksv + this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                noofstocks +=  this.rawData['holdings_summary']['mcaptypewisenew']['q1_a_greater']['number'][item];
                this.valueGrowthData.push(growthValueData);
              }
            }
            let growthTotal = 0;
            if(q1_b_greaterGrowth) {
              for(let [item, key] of Object.entries(q1_b_greaterGrowth)) {
                console.log('item', item); 
                let index = this.valueGrowthData.findIndex(res => { 
                  return res.title == item
                });
                if(index != -1) {
                  this.valueGrowthData[index].growth = key;
                  this.valueGrowthData[index].sum += key;
                  growthTotal = growthTotal + key;
                  overAllTotal = overAllTotal + key;
                  this.valueGrowthData[index].noofstocksg = this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                  this.valueGrowthData[index].noofstocksmcap += this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                  noofstocksg += this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                  noofstocks += this.rawData['holdings_summary']['mcaptypewisenew']['q1_b_greater']['number'][item];
                } else {
                  let growthValueData = {
                    title: '',
                    value: '',
                    growth: '',
                    sum: 0,
                  }
                  growthValueData.title = item;
                  growthValueData.growth = key;
                  growthValueData.sum += key;
                  growthTotal = growthTotal + key;
                  overAllTotal = overAllTotal + key;
                  this.valueGrowthData.push(growthValueData);
                  } 
              }
            }
            this.valueVsGrowthTotal = { value: valueTotal, growth: growthTotal, total: overAllTotal, noofstocksv: noofstocksv, noofstocksg: noofstocksg, noofstocks: noofstocks};
            console.log('valueGrowthData result', this.valueGrowthData);
            this.getSchemeRollingReturns(mfcode);
          }
        });
    },
    search() {
      // console.log(this.searchP11);
      this.rawData = this.searchData.filter(rd => {
          console.log(rd);
          var searchTxt, schName, cat, funMng, rating, q1ab, p11, p11qtr = false;
          if((this.searchText.length > 2 && rd.LNAME)) 
            searchTxt = rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase());
          if((this.scheme_name.length > 2 && rd.sch_name)) 
            schName = rd.LNAME.toLowerCase().includes(this.scheme_name.toLowerCase());
          if((this.category.length > 2 && rd.Category))
            cat = rd.Category.toLowerCase().includes(this.category.toLowerCase());
          if((this.selFundManager != null && rd['FundManager']))
            funMng = rd['FundManager'].toLowerCase() == this.selFundManager.name.toLowerCase();
          if(this.searchPortfolioRating.max.length > 1 && this.searchPortfolioRating.min.length > 1 && rd['portfolio_overall_rating']) {
            rating = (rd['portfolio_overall_rating'] >= parseFloat(this.searchPortfolioRating.min) &&  rd['portfolio_overall_rating'] < parseFloat(this.searchPortfolioRating.max));
          } else if(this.searchPortfolioRating.min.length > 1 && rd['portfolio_overall_rating']) {
            rating = (rd['portfolio_overall_rating'] >= parseFloat(this.searchPortfolioRating.min));
          } else {
            rating = (rd['portfolio_overall_rating'] <= parseFloat(this.searchPortfolioRating.max));
          }
          if(this.searchq1ab.max.length > 1 && this.searchq1ab.min.length > 1 && rd['q1_a_b_greater_%_hldg_sum']) {
            q1ab = (rd['q1_a_b_greater_%_hldg_sum'] >= parseFloat(this.searchq1ab.min) &&  rd['q1_a_b_greater_%_hldg_sum'] < parseFloat(this.searchq1ab.max));
          } else if(this.searchq1ab.min.length > 1 && rd['q1_a_b_greater_%_hldg_sum']) {
            q1ab = (rd['q1_a_b_greater_%_hldg_sum'] >= parseFloat(this.searchq1ab.min));
          } else {
            q1ab = (rd['q1_a_b_greater_%_hldg_sum'] <= parseFloat(this.searchq1ab.max));
          }
          if(this.searchp11qtr.max.length > 1 && this.searchp11qtr.min.length > 1 && rd['p11_quarterly_trends_%_hldg_sum']) {
            p11qtr = (rd['p11_quarterly_trends_%_hldg_sum'] >= parseFloat(this.searchp11qtr.min) &&  rd['p11_quarterly_trends_%_hldg_sum'] < parseFloat(this.searchp11qtr.max));
          } else if(this.searchp11qtr.min.length > 1 && rd['p11_quarterly_trends_%_hldg_sum']) {
            p11qtr = (rd['p11_quarterly_trends_%_hldg_sum'] >= parseFloat(this.searchp11qtr.min));
          } else {
            p11qtr = (rd['p11_quarterly_trends_%_hldg_sum'] <= parseFloat(this.searchp11qtr.max));
          }
          if(this.searchP11.max.length > 1 && this.searchP11.min.length > 1 && rd['p11_S_%_hldg_sum']) {
            p11 = (rd['p11_S_%_hldg_sum'] >= parseFloat(this.searchP11.min) &&  rd['p11_S_%_hldg_sum'] < parseFloat(this.searchP11.max));
          } else if(this.searchP11.min.length > 1 && rd['p11_S_%_hldg_sum']) {
            p11 = (rd['p11_S_%_hldg_sum'] >= parseFloat(this.searchP11.min));
          } else {
            p11 = (rd['p11_S_%_hldg_sum'] <= parseFloat(this.searchP11.max));
          }
          return (searchTxt || schName || cat || funMng || rating || q1ab || p11 || p11qtr);
        //   return (
        //       ((this.searchText.length > 2 && rd.LNAME)? rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase()): false) || 
        //       ((this.scheme_name.length > 2 && rd.sch_name)? rd.LNAME.toLowerCase().includes(this.scheme_name.toLowerCase()): false) || 
        //       ((this.category.length > 2 && rd.Category)? rd.Category.toLowerCase().includes(this.category.toLowerCase()): false) ||
        //       ((this.selFundManager != null && rd['FundManager'])? rd['FundManager'].toLowerCase() == this.selFundManager.name.toLowerCase(): false) ||
        //       ((this.searchPortfolioRating.min.length > 1 && rd['portfolio_overall_rating'])? rd['portfolio_overall_rating'] >= parseFloat(this.searchPortfolioRating.min): false &&
        //       ((this.searchPortfolioRating.max.length > 1 && rd['portfolio_overall_rating'])? rd['portfolio_overall_rating'] < parseFloat(this.searchPortfolioRating.max): false)) || 
        //       ((this.searchq1ab.min.length > 1 && rd['q1_a_b_greater_%_hldg_sum'])? rd['q1_a_b_greater_%_hldg_sum'] >= parseFloat(this.searchq1ab.min): false &&
        //       ((this.searchq1ab.max.length > 1 && rd['q1_a_b_greater_%_hldg_sum'])? rd['q1_a_b_greater_%_hldg_sum'] < parseFloat(this.searchq1ab.max): false)) ||
        //       ((this.searchp11qtr.max.length > 1 && rd['p11_quarterly_trends_%_hldg_sum'])? rd['p11_quarterly_trends_%_hldg_sum'] >= parseFloat(this.searchp11qtr.max): false  &&
        //       ((this.searchp11qtr.min.length > 1 && rd['p11_quarterly_trends_%_hldg_sum'])? rd['p11_quarterly_trends_%_hldg_sum'] < parseFloat(this.searchp11qtr.min): false)) ||
        //       ((this.searchP11.min.length > 1 && rd['p11_S_%_hldg_sum'])? rd['p11_S_%_hldg_sum'] >= parseFloat(this.searchP11.min): false &&
        //       ((this.searchP11.max.length > 1 && rd['p11_S_%_hldg_sum'])? rd['p11_S_%_hldg_sum'] < parseFloat(this.searchP11.max): false))
        //   )
        });
      // }
    },
    getFundManagerList() {
      let _this = this;
      http.get("mutual-funds/fund-manager", {}, function(error, response) {
        if(response.status == 'success'){
          var fundManagerList = response.data;
          var uniqueFundManagers = [];
          if (fundManagerList.length > 0) {
            fundManagerList.forEach((fundManager) => {
              if(_this.checkNotInArray(uniqueFundManagers, fundManager.fund_mgr)) {
                uniqueFundManagers.push(fundManager.fund_mgr);
                _this.fundManagerList.push({name: fundManager.fund_mgr, fund_manager: fundManager.fund_mgr});
              }
            });
            _this.fundManagerList = _this.sorted_fields_asc(
              _this.fundManagerList,
              "name"
            );
            // if (!localStorage.getItem("selFundManager")) {
            //   _this.selFundManager = _this.fundManagerList[0];
            //   localStorage.setItem("selFundManager", JSON.stringify(_this.selFundManager));
            // } else {
            //   _this.selFundManager = JSON.parse(localStorage.getItem("selFundManager"));
            // }
            console.log("Selected FundManager", typeof _this.selFundManager, _this.fundManagerList);
          }
        }
      });
    },
    filterSchemes() {
      console.log(this.selFundManager, this.selFundManager != null);
      if(this.scheme_name.length > 1 || this.selFundManager != null || this.category.length > 1 || this.searchText.length > 1
         || this.searchP11.min.length > 1  || this.searchp11qtr.min.length > 1  || this.searchq1ab.min.length > 1  || this.searchPortfolioRating.min.length > 1
         || this.searchP11.max.length > 1  || this.searchp11qtr.max.length > 1  || this.searchq1ab.max.length > 1  || this.searchPortfolioRating.max.length > 1) {
        this.search();
        console.log('Search');
      } else {
        this.rawData = this.searchData;
      }
    },
    resetFilter() {
      this.selFundManager = null;
      this.scheme_name = this.category = this.searchText = '';
      this.searchP11 = this.searchp11qtr = this.searchq1ab = this.searchPortfolioRating = {min: '', max: ''};
      this.rawData = this.searchData;
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      this.showSchemeHoldings();
    },
    getSchemeRollingReturns(mfcode = null) {
      var APIURL = this.rawDataApi + 'scheme-rolling-returns';
      if(mfcode!=null) {
        APIURL = APIURL + '/' + mfcode;
      }
      APIURL = APIURL + '?duration=3M';
      http.get(
        APIURL,
        {},
        (error, response) => {
          console.log(response);
        });
    }
  },
  data() {
    return {
      durDate: null,
      selScheme: '',
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      valueVsGrowthTotal: { value: 0, growth: 0, total: 0, noofstocksv: 0 , noofstocksg: 0, noofstocks: 0 },
      tableFields: [
          {
            title: 'mf_schcode',
            name: this.getLabel('mf_schcode'),
            isLink: 0,
            datatype: '',
            sort_order: 1,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'date',
            name: this.getLabel('date'),
            isLink: 0,
            datatype: 'date',
            sort_order: 2,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'MF_COCODE',
            name: this.getLabel('MF_COCODE'),
            isLink: 0,
            datatype: '',
            sort_order: 3,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'LNAME',
            name: this.getLabel('LNAME'),
            isLink: 0,
            datatype: '',
            sort_order: 4,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'sch_name',
            name: this.getLabel('sch_name'),
            isLink: 0,
            datatype: '',
            sort_order: 5,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'Category',
            name: this.getLabel('Category'),
            isLink: 0,
            datatype: '',
            sort_order: 6,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'FundManager',
            name: this.getLabel('FundManager'),
            isLink: 0,
            datatype: '',
            sort_order: 7,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'scheme_ratios_date',
            name: this.getLabel('scheme_ratios_date'),
            isLink: 0,
            datatype: 'date',
            sort_order: 8,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'ALPHA',
            name: this.getLabel('ALPHA'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 9,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'BETA',
            name: this.getLabel('BETA'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 10,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'AVERAGE',
            name: this.getLabel('AVERAGE'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 11,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'NAV',
            name: this.getLabel('NAV'),
            isLink: 0,
            datatype: '',
            sort_order: 12,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'RSQUARE',
            name: this.getLabel('RSQUARE'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 13,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'SD',
            name: this.getLabel('SD'),
            isLink: 0,
            datatype: '',
            sort_order: 14,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'SHARPE',
            name: this.getLabel('SHARPE'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 15,
            sort: 0,
            isSortable: 1
          },          
          {
            title: 'scheme_returns_date',
            name: this.getLabel('returns_date'),
            isLink: 0,
            datatype: 'date',
            sort_order: 16,
            sort: 0,
            isSortable: 1
          },
          {
            title: '1month',
            name: this.getLabel('1 M'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 17,
            sort: 0,
            isSortable: 1
          },
          {
            title: '3month',
            name: this.getLabel('3 M'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 18,
            sort: 0,
            isSortable: 1
          },
          {
            title: '6month',
            name: this.getLabel('6 M'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 19,
            sort: 0,
            isSortable: 1
          },
          {
            title: '1year',
            name: this.getLabel('1 Yr'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 20,
            sort: 0,
            isSortable: 1
          },
          {
            title: '3year',
            name: this.getLabel('3 Yrs'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 21,
            sort: 0,
            isSortable: 1
          },
          {
            title: '5year',
            name: this.getLabel('5 Yrs'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 22,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'inception',
            name: this.getLabel('inception'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 23,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'EXPRATIO',
            name: this.getLabel('Exp Ratio'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 24,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p1_S_%_hldg',
            name: this.getLabel('p1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 25,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p2_S_%_hldg',
            name: this.getLabel('p2_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 26,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p3_S_%_hldg',
            name: this.getLabel('p3S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 26,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p4_S_%_hldg',
            name: this.getLabel('p4_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 27,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p5_a_S_%_hldg',
            name: this.getLabel('p5_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 28,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p5_b_S_%_hldg',
            name: this.getLabel('p5_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 29,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p6_a_%_hldg',
            name: this.getLabel('p6_a_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 30,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p7_a_S_%_hldg',
            name: this.getLabel('p7_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 31,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p7_b_S_%_hldg',
            name: this.getLabel('p7_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 32,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p8_a_S_%_hldg',
            name: this.getLabel('p8_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 33,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p8_b_S_%_hldg',
            name: this.getLabel('p8_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 34,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p9_S_%_hldg',
            name: this.getLabel('p9_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p10_S_%_hldg',
            name: this.getLabel('p10_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 36,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p11_debt_%_hldg',
            name: this.getLabel('p11_debt_rating_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 36
          },
          {
            title: 'p11_S_%_hldg',
            name: this.getLabel('p11_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 37,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p11_quarterly_trends_%_hldg',
            name: this.getLabel('p11_quarterly_trends_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 38,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'q1_S_%_hldg',
            name: this.getLabel('q1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 40,
            sort: 0,
            isSortable: 1
          },          
          // {
          //   title: 'q1_a_greater',
          //   name: this.getLabel('q1_a_greater'),
          //   isLink: 0,
          //   datatype: 'numeric',
          //   sort_order: 41,
          //   sort: 0,
          //   isSortable: 1
          // },
          // {
          //   title: 'q1_b_greater',
          //   name: this.getLabel('q1_b_greater'),
          //   isLink: 0,
          //   datatype: 'numeric',
          //   sort_order: 41,
          //   sort: 0,
          //   isSortable: 1
          // },
          {
            title: 'q1_a_S_%_hldg',
            name: this.getLabel('q1_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 42,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'q1_b_S_%_hldg',
            name: this.getLabel('q1_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 44,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'q1_a_b_greater_%_hldg',
            name: this.getLabel('q1_a_b_greater_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 46,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'q1_c_S_%_hldg',
            name: this.getLabel('q1_c_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 48,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'q1_d_S_%_hldg',
            name: this.getLabel('q1_d_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 50,
            sort: 0,
            isSortable: 1
          },
      ],
      tableFields1: [
          {
            title: 'mf_schcode',
            name: this.getCustomLabel('mf_schcode')? this.getCustomLabel('mf_schcode'): this.getLabel('mf_schcode'),
            isLink: 0,
            datatype: 'string',
            sort_order: 1,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'date',
            name: this.getCustomLabel('date')? this.getCustomLabel('date'):this.getLabel('date'),
            isLink: 0,
            datatype: 'date',
            sort_order: 2,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'MF_COCODE',
            name: this.getCustomLabel('MF_COCODE')? this.getCustomLabel('MF_COCODE'): this.getLabel('MF_COCODE'),
            isLink: 0,
            datatype: 'string',
            sort_order: 3,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'LNAME',
            name: this.getCustomLabel('LNAME')? this.getCustomLabel('LNAME'): this.getLabel('LNAME'),
            isLink: 0,
            datatype: 'string',
            sort_order: 4,
            sort: 0,
            isSortable: 1,
            isNumeric: 0
          },
          {
            title: 'sch_name',
            name: this.getCustomLabel('sch_name')? this.getCustomLabel('sch_name'):this.getLabel('sch_name'),
            isLink: 0,
            datatype: 'string',
            sort_order: 5,
            sort: 0,
            isSortable: 1,
            isNumeric: 0
          },
          {
            title: 'Category',
            name: this.getCustomLabel('Category')? this.getCustomLabel('Category'): this.getLabel('Category'),
            isLink: 0,
            datatype: 'string',
            sort_order: 6,
            sort: 0,
            isSortable: 1,
            isNumeric: 0
          },
          {
            title: 'FundManager',
            name: this.getCustomLabel('FundManager')? this.getCustomLabel('FundManager'): this.getLabel('FundManager'),
            isLink: 0,
            datatype: 'string',
            sort_order: 7,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'scheme_ratios_date',
            name: this.getCustomLabel('scheme_ratios_date')? this.getCustomLabel('scheme_ratios_date'): this.getLabel('scheme_ratios_date'),
            isLink: 0,
            datatype: 'date',
            sort_order: 8,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'ALPHA',
            name: this.getCustomLabel('ALPHA')? this.getCustomLabel('ALPHA'): this.getLabel('ALPHA'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 9,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'BETA',
            name: this.getCustomLabel('BETA')? this.getCustomLabel('BETA'): this.getLabel('BETA'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 10,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'AVERAGE',
            name: this.getCustomLabel('AVERAGE')? this.getCustomLabel('AVERAGE'): this.getLabel('AVERAGE'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 11,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'NAV',
            name: this.getCustomLabel('NAV')? this.getCustomLabel('NAV'): this.getLabel('NAV'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 12,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'RSQUARE',
            name: this.getCustomLabel('RSQUARE')? this.getCustomLabel('RSQUARE'): this.getLabel('RSQUARE'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 13,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'SD',
            name: this.getCustomLabel('SD')? this.getCustomLabel('SD'): this.getLabel('SD'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 14,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'SHARPE',
            name: this.getCustomLabel('SHARPE')? this.getCustomLabel('SHARPE'): this.getLabel('SHARPE'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 15,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'SchemeAUM',
            name: this.getCustomLabel('SchemeAUM')? this.getCustomLabel('SchemeAUM'): this.getLabel('SchemeAUM'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 16,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },          
          {
            title: 'scheme_returns_date',
            name: this.getLabel('returns_date'),
            isLink: 0,
            datatype: 'date',
            sort_order: 17,
            sort: 0,
            isSortable: 1
          },
          {
            title: '1month',
            name: this.getLabel('1 M'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 18,
            sort: 0,
            isSortable: 1
          },
          {
            title: '3month',
            name: this.getLabel('3 M'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 19,
            sort: 0,
            isSortable: 1
          },
          {
            title: '6month',
            name: this.getLabel('6 M'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 20,
            sort: 0,
            isSortable: 1
          },
          {
            title: '1year',
            name: this.getLabel('1 Yr'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 21,
            sort: 0,
            isSortable: 1
          },
          {
            title: '3year',
            name: this.getLabel('3 Yrs'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 22,
            sort: 0,
            isSortable: 1
          },
          {
            title: '5year',
            name: this.getLabel('5 Yrs'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 23,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'inception',
            name: this.getLabel('inception'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 23,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'EXPRATIO',
            name: this.getLabel('Exp Ratio'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 24,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p1_S_%_hldg',
            name: this.getCustomLabel('p1_S_%_hldg')? this.getCustomLabel('p1_S_%_hldg'): this.getLabel('p1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 25,
            sort: 0,
            isSortable: 1
          },
          {
            title: 'p2_S_%_hldg',
            name: this.getCustomLabel('p2_S_%_hldg')? this.getCustomLabel('p2_S_%_hldg'): this.getLabel('p2_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 26,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p3_S_%_hldg',
            name: this.getCustomLabel('p3S_%_hldg')? this.getCustomLabel('p3S_%_hldg'): this.getLabel('p3S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 27,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p4_S_%_hldg',
            name: this.getCustomLabel('p4_S_%_hldg')? this.getCustomLabel('p4_S_%_hldg'): this.getLabel('p4_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 28,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p5_a_S_%_hldg',
            name: this.getCustomLabel('p5_a_S_%_hldg')? this.getCustomLabel('p5_a_S_%_hldg'): this.getLabel('p5_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 29,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p5_b_S_%_hldg',
            name: this.getCustomLabel('p5_b_S_%_hldg')? this.getCustomLabel('p5_b_S_%_hldg'): this.getLabel('p5_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 30,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p6_a_%_hldg',
            name: this.getCustomLabel('p6_a_%_hldg')? this.getCustomLabel('p6_a_%_hldg'): this.getLabel('p6_a_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 31,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p7_a_S_%_hldg',
            name: this.getCustomLabel('p7_a_S_%_hldg')? this.getCustomLabel('p7_a_S_%_hldg'): this.getLabel('p7_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 32,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p7_b_S_%_hldg',
            name: this.getCustomLabel('p7_b_S_%_hldg')? this.getCustomLabel('p7_b_S_%_hldg'): this.getLabel('p7_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 33,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p8_a_S_%_hldg',
            name: this.getCustomLabel('p8_a_S_%_hldg')? this.getCustomLabel('p8_a_S_%_hldg'): this.getLabel('p8_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 34,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p8_b_S_%_hldg',
            name: this.getCustomLabel('p8_b_S_%_hldg')? this.getCustomLabel('p8_b_S_%_hldg'): this.getLabel('p8_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p9_S_%_hldg',
            name: this.getCustomLabel('p9_S_%_hldg')? this.getCustomLabel('p9_S_%_hldg'): this.getLabel('p9_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 36,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p10_S_%_hldg',
            name: this.getCustomLabel('p10_S_%_hldg')? this.getCustomLabel('p10_S_%_hldg'): this.getLabel('p10_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 37,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p11_debt_%_hldg',
            name: this.getLabel('p11_debt_rating_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 35
          },
          {
            title: 'p11_S_%_hldg',
            name: this.getCustomLabel('p11_S_%_hldg')? this.getCustomLabel('p11_S_%_hldg'): this.getLabel('p11_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 38,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'p11_quarterly_trends_%_hldg',
            name: this.getCustomLabel('p11_quarterly_trends_%_hldg')? this.getCustomLabel('p11_quarterly_trends_%_hldg'): this.getLabel('p11_quarterly_trends_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 39,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'q1_S_%_hldg',
            name: this.getCustomLabel('q1_S_%_hldg')? this.getCustomLabel('q1_S_%_hldg'): this.getLabel('q1_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 40,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'q1_a_S_%_hldg',
            name: this.getCustomLabel('q1_a_S_%_hldg')? this.getCustomLabel('q1_a_S_%_hldg'): this.getLabel('q1_a_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 42,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'q1_b_S_%_hldg',
            name: this.getCustomLabel('q1_b_S_%_hldg')? this.getCustomLabel('q1_b_S_%_hldg'): this.getLabel('q1_b_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 44,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'q1_a_b_greater_%_hldg',
            name: this.getCustomLabel('q1_a_b_greater_%_hldg')? this.getCustomLabel('q1_a_b_greater_%_hldg'): this.getLabel('q1_a_b_greater_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 46,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'q1_c_S_%_hldg',
            name: this.getCustomLabel('q1_c_S_%_hldg')? this.getCustomLabel('q1_c_S_%_hldg'): this.getLabel('q1_c_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 48,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'q1_d_S_%_hldg',
            name: this.getCustomLabel('q1_d_S_%_hldg')? this.getCustomLabel('q1_d_S_%_hldg'): this.getLabel('q1_d_S_%_hldg'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 50,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
          {
            title: 'portfolio_overall_rating',
            name: this.getLabel('portfolio_overall_rating')? this.getLabel('portfolio_overall_rating'): this.getLabel('portfolio_overall_rating'),
            isLink: 0,
            datatype: 'numeric',
            sort_order: 51,
            sort: 0,
            isSortable: 1,
            isNumeric: 1
          },
      ],
      ratings: 
          {
            title: 'ratings', 
            name: 'Ratings',
            datatype: 'numeric',
            sort_order: 51,
            sort: 0,
            isSortable: 1,
            subFields: [      
            {
              title: 'p11_S_%_hldg', 
              name: this.getCustomLabel('p11_S_%_hldg')? this.getCustomLabel('p11_S_%_hldg'): this.getLabel('p11_S_%_hldg'),
              datatype: 'numeric',
              sort_order: 51,
              sort: 0,
              isSortable: 1
            },
            {
              title: 'p11_quarterly_trends_%_hldg',
              name: this.getCustomLabel('p11_quarterly_trends_%_hldg')? this.getCustomLabel('p11_quarterly_trends_%_hldg'): this.getLabel('p11_quarterly_trends_%_hldg'),
              datatype: 'numeric',
              sort_order: 52,
              sort: 0,
              isSortable: 1
            },
            {
              title: 'q1_a_b_greater_%_hldg',
              name: this.getCustomLabel('q1_a_b_greater_%_hldg')? this.getCustomLabel('q1_a_b_greater_%_hldg'): this.getLabel('q1_a_b_greater_%_hldg'),
              datatype: 'numeric',
              sort_order: 53,
              sort: 0,
              isSortable: 1
            },
            {
              title: 'p11_debt_%_hldg',
              name: this.getCustomLabel('p11_debt_%_hldg')? this.getCustomLabel('p11_debt_%_hldg'): this.getLabel('p11_debt_%_hldg'),
              datatype: 'numeric',
              sort_order: 54,
              sort: 0,
              isSortable: 1
            },
            {
              title: 'portfolio_overall_rating', 
              name: this.getCustomLabel('portfolio_overall_rating')? this.getCustomLabel('portfolio_overall_rating'): this.getLabel('portfolio_overall_rating'),
              datatype: 'numeric',
              sort_order: 55,
              sort: 0,
              isSortable: 1
            }
            ]
          },
      sum: {},
      searchText: '',
      selFundManager: null,
      fundManagerList: [],
      scheme_name: '',
      category: '',
      searchP11: {min: '', max: ''},
      searchp11qtr: {min: '', max: ''},
      searchq1ab: {min: '', max: ''},
      searchPortfolioRating: {min: '', max: ''},
      rawDataType: "analysis-sum",
      rawDataApi: "mutual-funds/",
      rawData: [],
      valueGrowthData: [],
      searchData: [],
      mfSCHCode: '',
      holding_summary: [
        {
          title: 'industrywise',
          name: 'Industry-wise'
        },
        {
          title: 'mcaptypewise',
          name: 'M Cap-wise'
        },
        {
          title: 'typewise',
          name: 'Type-wise'
        },
        {
          title: 'psumratingwise',
          name: 'P Sum Rating-wise'
        },
        {
          title: 'top_3_exposures',
          name: 'Top 3 Exposures'
        },
        {
          title: 'credit_ratings',
          name: 'Credit Ratings'
        }
      ],
      industryKeys: [
        { title: 'name', name: 'Sector' },
        { title: 'value', name: '% Holding' }
      ],
      typewiseKeys: [
        { title: 'name', name: 'Type' },
        { title: 'value', name: '% Holding' },
        { title: 'holdCount', name: 'Count' },
      ],
      mcapKeys: [],
      psumratingwiseKeys: [],
      top3exposuresKeys: [],
      top3industryKeys: [],
      businessRatings: [],
      businessRatingKeys: [7,6,5,4,3,2,1],
      valuationRatingKeys: [5,4,3,2,1],
      qtrRatingKeys: [5,4,3,2,1],
      valuationRatings: [],
      qtrRatings: [],
      debtRatingKeys: [7,6,5,4,3,2,1],
      debtRatings: [],
      crRatingKeys: [
        {
          title: 'name',
          name: this.getLabel('name'),
          isLink: 0,
          datatype: 'string',
          sort_order: 2,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'PERC_HOLD',
          name: this.getLabel('% Hold'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 3,
          sort: 0,
          isSortable: 1
        },
      ],
      creditRatingsKeys: [
        {
          title: 'type',
          name: 'Type',
          isLink: 0,
          datatype: 'string',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'name',
          name: this.getLabel('name'),
          isLink: 0,
          datatype: 'string',
          sort_order: 2,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'PERC_HOLD',
          name: this.getLabel('% Hold'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 3,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_S_%_hldg',
          name: this.getLabel('business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 4,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_S_%_hldg_adj',
          name: this.getLabel('adj_business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 7,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_a_b_greater_%_hldg',
          name: this.getLabel('valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 5,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'q1_a_b_greater_%_hldg_adj',
          name: this.getLabel('adj_valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 8,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_quarterly_trends_%_hldg',
          name: this.getLabel('quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_quarterly_trends_%_hldg_adj',
          name: this.getLabel('adj_quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_debt_%_hldg',
          name: this.getLabel('Debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'p11_debt_%_hldg_adj',
          name: this.getLabel('adj_debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating',
          name: this.getLabel('Overall Rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating_adj',
          name: this.getLabel('adj_overall_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1
        }
      ],

      overallRatingKeys: [
        {
          title: 'overall_business_rating',
          name: 'Business Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_valuation_rating',
          name: 'Valuation Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_quarterly_rating',
          name: 'Quarterly Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_debt_others_rating',
          name: 'Debt & Others Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_equity_rating',
          name: 'Equity Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_scheme_rating',
          name: 'Scheme Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_weighted_scheme_rating',
          name: 'Weighted Scheme Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
      ]
    };
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/analysis-sum.vue